import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { SiteFilter, StatusFilter, TimeRangeFilter } from '../../filters';
import WirelessControllerListPanel from '../../panels/ipm-list-panels/WirelessControllerListPanel';

export const pageId = 'wireless-controllers';

export default function WirelessControllersPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Wireless Controllers`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <WirelessControllerListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
